import * as React from "react"
export const ToolbarNet = (props:any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
        height={20}
         viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g
      stroke="#6C757D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="m.833 17.5 2.62-15h13.094l2.62 15H.833ZM1.667 13.75h16.666M2.5 10h15M3.333 6.25h13.334M10 2.5v15M6.667 2.917l-1.25 14.167M13.333 2.917l1.25 14.167" />
    </g>
  </svg>
)
